module.exports = __webpack_public_path__ + "static/img/三维动画.4a50611.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10006/三维动画.png
// module id = pl+g
// module chunks = 1